// src/pages/auth/redirectResetPassword.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RedirectResetPassword = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect after a short delay or immediately
    // Adjust the path as needed (e.g., '/update-password' or '/login')
    navigate('/update-password', { replace: true });
  }, [navigate]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
      }}
    >
      <h2>Redirecting to password reset...</h2>
      <p>
        If you are not redirected, <a href="/update-password">click here</a>.
      </p>
    </div>
  );
};

export default RedirectResetPassword;
